import { useAmplitude } from "lib/amplitude/Amplitude";
import Link from "next/link";

interface IMustBePremiumToSeeMoreNoticeProps {
  totalOfComments?: number | null;
}

export default function MustBePremiumToSeeMoreNotice({ totalOfComments = null }: IMustBePremiumToSeeMoreNoticeProps) {
  const amplitude = useAmplitude();

  const clickHereToBecomePremium = (
    <Link
      href="/premium"
      className="font-medium text-blue-600 hover:underline"
      onClick={() => {
        amplitude.logEvent("Click on link to become Premium", {
          origin: "Must be premium to see more",
        });
      }}
    >
      Só no Premium!
    </Link>
  );

  let noticeContent = (
    <p className="text-center font-aeonik text-base font-normal">
      Você precisa ser <strong>Premium</strong> para que possa acompanhar a discussão e ver os comentários mais antigos!{" "}
      {clickHereToBecomePremium}
    </p>
  );

  if (totalOfComments !== null && totalOfComments > 1) {
    noticeContent = (
      <p className="text-center font-aeonik text-base font-normal">
        Quer ver todos os <strong>{totalOfComments} comentários</strong> e respostas? {clickHereToBecomePremium}
      </p>
    );
  }

  return <div className="rounded-lg bg-slate-50 p-6">{noticeContent}</div>;
}
